import {addContainer, initStore} from '../utils/store';
import marathons from './reducers';
import LanguageController from './components/LanguageController';
import LanguageSelector from './components/LanguageSelector';
import ReviewSwiper from './components/ReviewSwiper';
import {ButtonFree, ButtonFreePromo, ButtonPaid} from './components/ButtonFree';
import MarathonBg from './components/MarathonBg';


import './styles/index.scss';

addContainer('LanguageController', LanguageController);
addContainer('LanguageSelector', LanguageSelector);
addContainer('ReviewSwiper', ReviewSwiper);
addContainer('ButtonFree', ButtonFree);
addContainer('ButtonFreePromo', ButtonFreePromo);
addContainer('ButtonPaid', ButtonPaid);
addContainer('MarathonBg', MarathonBg);


initStore({
    marathons,
});



// WEBPACK FOOTER //
// ./src/marathons/app.js